import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    ramas: [],
  },

  getters: {
    getRamas: (state) => state.ramas,
  },

  mutations: {
    SET_RAMAS(state, ramas) {
      state.ramas = ramas;
    },
  },

  actions: {
    async fetchRamas({ commit }) {
      await axios
        .get('/EonCloud/common/ramas')
        .then((response) => {
          commit('SET_RAMAS', response.data.data);
        });
    },

    async fetchRamasByDependencia({ commit }, dependencia) {
      await axios
        .get(`/EonCloud/common/dependencias/${dependencia}/ramas`)
        .then((response) => {
          commit('SET_RAMAS', response.data.data);
        });
    },
  },
};
